import { render, staticRenderFns } from "./SortPanelContainer.vue?vue&type=template&id=68bb5d94&"
import script from "./SortPanelContainer.vue?vue&type=script&lang=ts&"
export * from "./SortPanelContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports